export enum StatusEnum {
  '完成' = '000',
  'Access Token無存取此路徑的權限' = '101',
  '不合法的Access Token' = '102',
  'Access Token過期' = '103',
  'Refresh Token過期' = '104',
  '使用者尚未完成登入作業' = '105',
  'Access Token產生失敗，請洽系統管理人員' = '106',
  '智能客服URL產生失敗，請洽系統管理人員' = '107',
}
export default StatusEnum;
